import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/store';

interface DisplayState {
  hideImages: boolean;
}

const initialState: DisplayState = {
  hideImages: true // default images hidden
};

const displaySlice = createSlice({
  name: 'display',
  initialState,
  reducers: {
    toggleHideImages: ( state ) => {
      state.hideImages = !state.hideImages;
    },
    setHideImages: ( state, action ) => {
      state.hideImages = action.payload;
    }
  }
});

export const { toggleHideImages, setHideImages } = displaySlice.actions;
export default displaySlice.reducer;
export const selectHideImages = ( state: RootState ) => state.spreadsheet.display.hideImages;